import { Box, Button } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { CANCEL_BUTTON, SAVE_BUTTON } from "./data-hooks";
const FooterActions = ({
  onCancel,
  onSave,
  logBi,
  dataHook,
  saveButtonLabel
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { align: "right", gap: "SP2" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: () => {
        logBi({ dataHook: classNames(CANCEL_BUTTON, dataHook) });
        onCancel();
      },
      priority: "secondary",
      dataHook: classNames(CANCEL_BUTTON, dataHook),
      size: "small"
    },
    t("SettingsPanelFooter_Cancel")
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: () => {
        logBi({ dataHook: classNames(SAVE_BUTTON, dataHook) });
        onSave();
      },
      priority: "primary",
      dataHook: classNames(SAVE_BUTTON, dataHook),
      size: "small"
    },
    saveButtonLabel ?? t("SettingsPanelFooter_Save")
  ));
};
export {
  FooterActions
};
//# sourceMappingURL=footer-actions.js.map
